@for (action of actions; track action; let i = $index) {
  <div class="mb-4">
    <div class="flex items-center">
      <p-radio-button
        [value]="action.value"
        [inputId]="'action_' + i"
        [disabled]="action.disabled"
        [(ngModel)]="nextAction"
      />
      <label [for]="'action_' + i" class="ml-2">{{ action.label }}</label>
    </div>
  </div>
}

@if (showWarning) {
  @if (showWarning) {
    <p-message
      class="block w-100 mb-4"
      severity="warn"
      styleClass="block w-100 p-message-sm"
      [text]="warningMessage"
    ></p-message>
  }
} @else {
  @if (continuedStayMessage?.severity === 'info') {
    <div class="mb-4">
      <p-message
        class="instruction-message secondary-message"
        severity="info"
        [escape]="false"
        [text]="continuedStayMessage?.detail"
      ></p-message>
    </div>
  } @else {
    @if (actionsMap['continuedStay'].disabled) {
      <div class="mb-4">
        <p-message
          class="instruction-message"
          severity="warn"
          [text]="continuedStayMessage?.detail"
        ></p-message>
      </div>
    }
  }
}


<div class="flex justify-end">
  <button pButton class="p-button-secondary mr-2" label="Cancel" (click)="onCancel()"></button>
  <button pButton label="Continue" [disabled]="!nextAction" (click)="onContinue(nextAction)"></button>
</div>
